export const processWord = (word: string, values: string[]) => {
  const processed = word.trim();
  return processed !== '' && !values.map((v) => v.toLowerCase()).includes(processed.toLowerCase())
    ? processed
    : undefined;
};

export const removeSpecialCharacters = (str: string) => str.replaceAll(/[^0-9\p{L} -]+/gu, '');
